/**
 * Chuẩn hóa đường dẫn ảnh từ src đầu vào
 * @param src - Source path của ảnh
 * @returns Đường dẫn đã chuẩn hóa
 */
const normalizeImagePath = (src: string): string => {
  if (!src || typeof src !== 'string') return ''
  let processedPath = src
    .replace(/^\/?image\//, 'uploads/')
    .replace(/^\//, '')
    .trim()

  // Xóa dấu `/` ở đầu nếu có
  if (processedPath.startsWith('/')) {
    processedPath = processedPath.slice(1)
  }

  // Nếu path đã bắt đầu bằng 'uploads/', giữ nguyên
  // Nếu không, thêm 'image/' vào đầu
  if (processedPath.includes('uploads/')) {
    // không cần chỉnh gì thêm
  } else if (!processedPath.startsWith('image/')) {
    processedPath = `image/${processedPath}`
  }
  return processedPath
}

/**
 * Tạo URL ảnh cho N7 media
 * @param processedPath - Đường dẫn đã chuẩn hóa
 * @param width - Chiều rộng ảnh
 * @returns URL ảnh N7 media
 */
const buildN7MediaUrl = (processedPath: string, width?: number): string => {
  const n7MediaUrl = process.env.NEXT_PUBLIC_N7_MEDIA_URL
  if (!n7MediaUrl) return ''
  if (width) {
    return `${n7MediaUrl}/${processedPath}?aio=w-${width}`
  }
  return `${n7MediaUrl}/${processedPath}`
}

/**
 * Tạo URL ảnh cho mediaUrl mặc định
 * @param processedPath - Đường dẫn đã chuẩn hóa
 * @param mediaUrl - Base media url
 * @param useMediaUrl - Có sử dụng media URL không
 * @returns URL ảnh media
 */
const buildDefaultMediaUrl = (
  processedPath: string,
  mediaUrl: string,
  useMediaUrl: boolean
): string => {
  // Tạo instance URL để xử lý path
  const url = new URL(mediaUrl.replace(/\/$/, ''))
  if (useMediaUrl) {
    // Không dùng vnis nữa nên không có các tham số
    url.pathname += `/${processedPath}`
  } else {
    url.pathname += `image/${processedPath}`
  }
  return url.toString()
}

/**
 * Xử lý URL ảnh giống như trong ImageCM component
 * @param src - Source path của ảnh
 * @param width - Chiều rộng ảnh
 * @param height - Chiều cao ảnh
 * @param useMediaUrl - Có sử dụng media URL không
 * @returns URL đã được xử lý
 */
export const processImageUrl = (
  src: string,
  width?: number,
  height?: number,
  useMediaUrl: boolean = false
): string => {
  const mediaUrl = process.env.NEXT_PUBLIC_MEDIA_URL || ''
  if (!src || typeof src !== 'string' || !mediaUrl) return ''

  try {
    const processedPath = normalizeImagePath(src)

    // Nếu có N7 media URL thì ưu tiên sử dụng
    if (process.env.NEXT_PUBLIC_N7_MEDIA_URL) {
      return buildN7MediaUrl(processedPath, width)
    }

    // Nếu không, build url theo mediaUrl mặc định, case này chắc k xảy ra nếu dùng n7 rồi
    return buildDefaultMediaUrl(processedPath, mediaUrl, useMediaUrl)
  } catch (error) {
    // Ghi log lỗi khi xử lý ảnh
    console.error('🚀 ~ processImageUrl ~ error:', error, src)
    return ''
  }
}
